// Copyright (c) 2016 Deere & Company

import './part-returns-settings.scss';
import React, {PropTypes} from 'react';
import {isFormValid, isPartRequestDaysToDisplayValid, isPartRequestStatusValid} from '../services/form-validation';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import ErrorMessage from '../../../shared/components/error-message';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import Modal from '../../../product/shared/state/modal';
import PartReturnsSettingsModel from '@deere/cps-it.warranty-model-factory/lib/part-return-settings';
import SettingsHeader from '../../shared/components/settings-header';
import ToggleCheckboxesButton from '../../../shared/components/toggle-checkboxes-button';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getToggleLabel} from '../../shared/services/user-settings-helpers';
import {withRouter} from 'react-router';

let unListen;

function handleStatusChange(status, isSelected) {

    this.actions.updatePartReturnsStatus(status, isSelected);

}

function handleDaysToDisplayChange(value) {

    const updatedValue = value ?
        parseFloat(value) :
        null;

    this.actions.updatePartReturnsNumberOfDays(updatedValue);

}

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleToggleAll() {

    this.actions.toggleAllPartReturnsStatus(this.userPartReturnSettings.status.allowedStatuses);

}

function handleConfirmSaveModal() {

    isFormValid(this.userPartReturnSettings) ?
        this.actions.confirmSaveModal(this.nextLocation) :
        this.actions.updateConfirmSaveModalVisibility(false);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

class PartReturnsSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        const isStatusValid = isPartRequestStatusValid(this.props.userPartReturnSettings.status.selectedStatuses);
        const isDaysToDisplayValid = isPartRequestDaysToDisplayValid(this.props.userPartReturnSettings.numberOfDays);

        return (
            <section className='part-returns-settings'>
                <SettingsHeader
                    className='part-returns-settings-header'
                    isSaveDisabled={this.props.isSaved || !isFormValid(this.props.userPartReturnSettings)}
                    onSave={this.props::handleUserSettingsSave}
                    title='PART_REQUESTS'
                />
                <span className='part-returns-settings-panel'>
                    <span className={`status ${isStatusValid ? '' : 'error'}`}>
                        <CheckboxListWithLabel
                            className='status-list'
                            initialState={createHashMap(this.props.userPartReturnSettings.status.selectedStatuses, 'key')}
                            isRequired={true}
                            label='STATUS'
                            list={addCollectionLabels(this.props.userPartReturnSettings.status.allowedStatuses, 'value')}
                            onChange={this.props::handleStatusChange}
                            uid='key'
                        />
                        <ErrorMessage
                            errorMessage='ONE_ITEM_MUST_BE_SELECTED'
                            isValid={isStatusValid}
                        />
                        <ToggleCheckboxesButton
                            label={getToggleLabel(this.props.userPartReturnSettings.status.selectedStatuses)}
                            listLength={this.props.userPartReturnSettings.status.allowedStatuses.length}
                            onClick={this.props::handleToggleAll}
                        />
                    </span>
                    <span className={`days-to-display ${isDaysToDisplayValid ? '' : 'error'}`}>
                        <section className='days-to-display-input'>
                            <FormattedMessage
                                id='DAYS_TO_DISPLAY'
                                tagName='h3'
                            />
                            <FormattedNumberInput
                                allowNegative={false}
                                isValidInput={value => value <= 1825}
                                onValueChange={this.props::handleDaysToDisplayChange}
                                value={this.props.userPartReturnSettings.numberOfDays}
                            />
                        </section>
                        <ErrorMessage
                            errorMessage='ENTER_A_NUMBER_FROM_1_TO_9999'
                            isValid={isDaysToDisplayValid}
                        />
                    </span>
                </span>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

PartReturnsSettings.displayName = 'PartReturnsSettings';
PartReturnsSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userPartReturnSettings: PropTypes.instanceOf(PartReturnsSettingsModel).isRequired
};

export default withRouter(PartReturnsSettings);



// WEBPACK FOOTER //
// ./src/user/part-returns-settings/components/part-returns-settings.js